import { getMessages } from '../../../../../../../store/constants';

export const CUSTOM_BUTTON_REMOVE_TOOLTIP = getMessages().getText('common.remove');
export const CUSTOM_ERROR_DUPLICATE = getMessages().getText('card_form_custom_section_error_duplicated');
export const CUSTOM_ERROR_EMPTY = getMessages().getText('card_form_custom_section_error_empty');
